import React, { useEffect } from "react";
import {
  AppBar,
  Toolbar,
  Box,
  Typography,
} from "@mui/material";
import { useNavigate, NavLink } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../hooks/store";
import { useGetProfileQuery } from "../services/auth";
import { setUserData } from "../reducers/authSlice";
import { DEFAULT_AVATAR, extractProfileData, getProfileDisplayName, getProfilePhotoUrl } from "../utils/profile";

function Topbar() {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const token = useAppSelector((state) => state.auth.token);
  const authUser = useAppSelector((state) => state.auth.userData);
  const { data: profileResponse } = useGetProfileQuery(undefined, {
    skip: !token,
    refetchOnMountOrArgChange: true,
  });

  useEffect(() => {
    if (window) {
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, []);

  useEffect(() => {
    const profile = extractProfileData(profileResponse);
    if (profile) dispatch(setUserData(profile));
  }, [profileResponse, dispatch]);

  const profileFromQuery = extractProfileData(profileResponse);
  const photoUrl =
    getProfilePhotoUrl(authUser) ||
    getProfilePhotoUrl(profileFromQuery) ||
    DEFAULT_AVATAR;
  const displayName = getProfileDisplayName(authUser);

  return (
    <Box className="site_header">
      <AppBar
        position="fixed"
        className="topbar"
        sx={{
          width: "100%",
          boxShadow: 'none',
        }}
      >
        <Toolbar sx={{ display: "flex", justifyContent: "space-between", padding: "0 25px !important" }}>
          <div className="topbar_left" style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }} onClick={() => navigate("/dashboard")}>
            <Typography component="h1" sx={{ fontSize: '20px', fontWeight: 700, color: '#fff', margin: 0 }}>
              It's My <span style={{ color: '#8CE352' }}>Wall</span>
            </Typography>
          </div>

          <div className="topbar_nav">
            <NavLink to="/dashboard">Design Engine</NavLink>
            <NavLink to="/recent-designs">My Design</NavLink>
            {/* <NavLink to="/how-it-works">How It Works</NavLink> */}
            <NavLink to="/support">Support</NavLink>
          </div>

          <div className="topbar_right">
            <Box>
              <div
                className="topbar_profile"
                onClick={() => navigate("/manage-profile", { state: { activeTab: "Profile" } })}
              >
                <img
                  src={photoUrl}
                  alt="Profile"
                  style={{ objectFit: 'cover' }}
                  onError={(e) => {
                    const current = e.currentTarget.src;
                    if (!current.includes("dummy-user.webp") && !current.includes("avtar.svg")) {
                      e.currentTarget.src = DEFAULT_AVATAR;
                    } else if (!current.includes("avtar.svg")) {
                      e.currentTarget.src = "/static/images/avtar.svg";
                    }
                  }}
                />
                <span>{displayName}</span>
              </div>
            </Box>
          </div>
        </Toolbar>
      </AppBar>
    </Box>
  );
}

export default Topbar;
